import axiosServices from 'utils/axios';
import { PlayerDto } from './dto';
import { InsideFifaBackOfficeEndpoints } from '../consts';

export const deletePlayer = async (player: PlayerDto): Promise<boolean> => {
    try {
        await axiosServices.delete<PlayerDto>(`${InsideFifaBackOfficeEndpoints.Players}/${player.id}`, {
            data: player,
        });

        return true;
    } catch (err) {
        throw err;
    }
};
